export const language = {
	'tr-TR': {
		'header.brand': 'Kimim Ben ? ',
		'header.contact': 'Bize Ulaş',
		'header.home': 'Anasayfa',
		'header.login': 'Giriş',
		'header.profile': 'Profil',
		'contact.name': 'Adınız',
		'contact.phoneNumber': 'Telefon Numaranız',
		'contact.email': 'E-posta Adresiniz',
		'contact.body': 'Mesajınız',
		'contact.button': 'Gönder',
		'contact.countrys': 'Ülkeniz',
		'contact.error': 'İşaretli alanları lütfen doldurun',
		'login.button': 'Giriş',
		'login.name': 'Adınız',
		'login.email': 'E-posta Adresiniz',
		'login.password': 'Şifreniz',
		'login.error': 'İşaretli alanları lütfen doldurun',
		'login.errorPasswordSpace': 'Şifre alanında lütfen boşluk karakteri kullanmayınız',
		'profile.userDetail': 'Kullanıcı Biglileri',
		'profile.logout': 'Çıkış',
		'user.header': 'Kullanıcı Bilgileri',
		'user.button': 'Güncelle',
		'modal.cancel':"Cancel",
		'modal.header':"Giriş",
		'home.dummyTextHeaderFirst':"Lorem Ipsum Nedir?",
		'home.dummyTextFirst':"Lorem Ipsum,dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir.Lorem Ipsum,adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır. 1960'larda Lorem Ipsum pasajları da içeren Letraset yapraklarının yayınlanması ile ve yakın zamanda Aldus PageMaker gibi Lorem Ipsum sürümleri içeren masaüstü yayıncılık yazılımları ile popüler olmuştur.",
		'home.dummyTextHeaderSecond':"Neden Kullanırız?",
		'home.dummyTextSecond':"Yinelenen bir sayfa içeriğinin okuyucunun dikkatini dağıttığı bilinen bir gerçektir. Lorem Ipsum kullanmanın amacı, sürekli 'buraya metin gelecek, buraya metin gelecek' yazmaya kıyasla daha dengeli bir harf dağılımı sağlayarak okunurluğu artırmasıdır. Şu anda birçok masaüstü yayıncılık paketi ve web sayfa düzenleyicisi, varsayılan mıgır metinler olarak Lorem Ipsum kullanmaktadır. Ayrıca arama motorlarında 'lorem ipsum' anahtar sözcükleri ile arama yapıldığında henüz tasarım aşamasında olan çok sayıda site listelenir. Yıllar içinde, bazen kazara, bazen bilinçli olarak (örneğin mizah katılarak), çeşitli sürümleri geliştirilmiştir.",
		'change.light':"Açık Tema",
		'change.dark':"Koyu Tema",
	},
	'en-US': {
		'header.brand': 'Who am I ?',
		'header.contact': 'Contact Us',
		'header.login': 'Login',
		'header.home': 'Home',
		'header.profile': 'Profile',
		'contact.name': 'Your Name',
		'contact.phoneNumber': 'Your Phone Number',
		'contact.email': 'Your E-mail',
		'contact.body': 'Your Message',
		'contact.countrys': 'Your Country',
		'contact.button': 'Send',
		'contact.error': 'Please fill in the marked fields',
		'login.button': 'Login',
		'login.name': 'Your Name',
		'login.email': 'Your E-mail',
		'login.password': 'Your Password',
		'login.error': 'Please fill in the marked fields',
		'login.errorPasswordSpace': 'Please dont use space in password field',
		'profile.userDetail': 'User Info',
		'profile.logout': 'Logout',
		'user.header': 'User Info',
		'user.button': 'Update',
		'modal.header':"Login",
		'modal.cancel':"Cancel",
		'home.dummyTextHeaderFirst': 'What is Lorem Ipsum?',
		'home.dummyTextFirst':
			"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
		'home.dummyTextHeaderSecond': 'Why do we use it?',
		'home.dummyTextSecond':
			"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
			'change.light':"Light Theme",
		'change.dark':"Dark Theme",
	},
};
